module.exports = __webpack_public_path__ + "media/images/lb/661-fd60bb38e73b55c1686a7dd60fe0be7a.svg";